
export default function getVersion() {
    //Up to 5 in release 2.2
    //Up to 6 in release 3.0
    return 6;
}
